import _ from 'lodash';

// App's event specific particular checking cases.
/**
 * INFO:
 * Add uniq cases in <section><element><effect> camel case format to maintain uniformity
 */
export const EVENT_SPECIFIC_CHECKING_CASES = {
  cookieButtonSameClass: 'cookie-button-same-class', // Cookie consent popup button classes
  sortAttendeeByLastName: 'sor-attendee-by-last-name' // Attendee sort based on last name first
};

// Checking case based settings manage switch case
export const checkEventSpecificCases = (eventId = null, checkCase = '') => {
  if (_.isNil(eventId) || _.isEmpty(checkCase)) return;

  // Maintain this format
  switch (checkCase) {
    case EVENT_SPECIFIC_CHECKING_CASES.cookieButtonSameClass:
      if (_.includes([1802726213403696], eventId)) {
        return 'custom-button-outerline-primary-md-hover';
      } else return 'custom-button-primary-md';

    case EVENT_SPECIFIC_CHECKING_CASES.sortAttendeeByLastName:
      return _.includes([1807941080452931], eventId);

    default:
      break;
  }
};
